// requestProgress.js

let activeRequests = 0;

const startRequest = () => {
    // if (activeRequests === 0) {
    //     // Trigger loading indicator or other actions
    //     console.log('Loading started');
    // }
    activeRequests = activeRequests + 1;
};

const endRequest = () => {
    activeRequests = activeRequests - 1;
    if (activeRequests < 0) {
        activeRequests = 0;
    }
};

const isInProgress = () => {
    return activeRequests > 0;
};

export { startRequest, endRequest, isInProgress };
